/**
 * Gap-filler wishlist: Cockpit API (DB + E-Mail) with Shopify contact form fallback.
 */
(() => {
  const root = document.querySelector('[data-gap-inquiry]');
  if (!root) return;

  const SENT_HANDLED_KEY = 'kl24_wishlist_sent_handled';
  const TITLE_FORM = 'Wunschliste senden';
  const TITLE_SUCCESS = 'Wunschliste gesendet';

  const overlay = root;
  const closeBtn = root.querySelector('[data-gap-inquiry-close]');
  const titleEl = root.querySelector('[data-gap-inquiry-title]');
  const formView = root.querySelector('[data-gap-inquiry-form-view]');
  const form = root.querySelector('.tcg-gap-inquiry__form--shopify');
  const summary = root.querySelector('[data-gap-inquiry-summary]');
  const tableBody = root.querySelector('[data-gap-inquiry-table-body]');
  const feedback = root.querySelector('[data-gap-inquiry-feedback]');
  const bodyField = root.querySelector('[data-gap-inquiry-body]');
  const submitBtn = root.querySelector('[data-gap-inquiry-submit]');
  const postSuccess = root.querySelector('[data-gap-inquiry-post-success]');
  const postSuccessText = root.querySelector('[data-gap-inquiry-success-text]');
  const openButtons = document.querySelectorAll(
    '[data-gap-send-wishlist], [data-gap-wishlist-drawer-inquiry]'
  );
  const wish = window.TcgGapWishlist;

  const resolveCockpitApiBase = () => {
    if (window.KL24?.resolveCockpitApiBase) {
      return window.KL24.resolveCockpitApiBase();
    }
    const fromRoot = root.dataset.apiBase || '';
    return String(fromRoot).trim().replace(/\/$/, '');
  };

  const cockpitHeaders = (apiBase, extra = {}) => {
    if (window.KL24?.cockpitRequestHeaders) {
      return window.KL24.cockpitRequestHeaders(apiBase, extra);
    }
    return { Accept: 'application/json', ...extra };
  };

  const LANGUAGE_OPTIONS = [
    { value: 'de', label: 'Deutsch' },
    { value: 'en', label: 'Englisch' },
    { value: 'jp', label: 'Japanisch' },
    { value: 'fr', label: 'Französisch' },
    { value: 'it', label: 'Italienisch' },
    { value: 'es', label: 'Spanisch' },
    { value: 'other', label: 'Andere' },
  ];

  const CONDITION_OPTIONS = [
    { value: 'NM', label: 'NM' },
    { value: 'EX', label: 'EX' },
    { value: 'LP', label: 'LP' },
    { value: 'MP', label: 'MP' },
    { value: 'DMG', label: 'DMG' },
  ];

  const VARIANT_LABELS = {
    standard: 'Normal',
    normal: 'Normal',
    reverse: 'Reverse Holo',
    holo: 'Holo',
  };

  const variantLabel = (key) => VARIANT_LABELS[String(key || '').toLowerCase()] || key || 'Normal';

  const resolveSetName = (handle) => {
    const resolver = window.TcgGapFillerSetNameForHandle;
    if (typeof resolver === 'function') {
      const name = resolver(handle);
      if (name && name !== handle) return name;
    }
    const listItem = document.querySelector(`[data-gap-set-list] [data-handle="${handle}"]`);
    if (listItem?.textContent) return listItem.textContent.trim();
    return handle;
  };

  const resolveEntry = (slotId) => {
    const resolver = window.TcgGapFillerResolveWishlistEntry;
    if (typeof resolver === 'function') {
      const entry = resolver(slotId);
      if (entry?.setName && entry.setName !== slotId.split('|')[0]) {
        return entry;
      }
      if (entry) {
        const handle = String(slotId || '').split('|')[0];
        return { ...entry, setName: resolveSetName(handle) };
      }
    }
    const parts = String(slotId || '').split('|');
    if (parts.length >= 3) {
      return {
        slotId,
        name: 'Unbekannte Karte',
        number: parts[1],
        variantLabel: variantLabel(parts[2]),
        setName: resolveSetName(parts[0]),
      };
    }
    return { slotId, name: slotId, number: '', variantLabel: '', setName: '' };
  };

  const buildSelect = (options, className, defaultValue) => {
    const select = document.createElement('select');
    select.className = className;
    options.forEach((opt) => {
      const option = document.createElement('option');
      option.value = opt.value;
      option.textContent = opt.label;
      if (opt.value === defaultValue) option.selected = true;
      select.appendChild(option);
    });
    return select;
  };

  const populateTable = () => {
    if (!tableBody || !wish) return;
    const slotIds = wish.loadAll();
    tableBody.replaceChildren();

    slotIds.forEach((slotId) => {
      const entry = resolveEntry(slotId);
      const tr = document.createElement('tr');
      tr.dataset.slotId = slotId;

      const setTd = document.createElement('td');
      setTd.textContent = entry.setName || '—';
      setTd.className = 'tcg-gap-inquiry__cell--readonly tcg-gap-inquiry__cell--set';
      setTd.title = entry.setName || '';
      tr.appendChild(setTd);

      [entry.number || '—', entry.name || '—', entry.variantLabel || '—'].forEach((text) => {
        const td = document.createElement('td');
        td.textContent = text;
        td.className = 'tcg-gap-inquiry__cell--readonly';
        tr.appendChild(td);
      });

      const langTd = document.createElement('td');
      langTd.appendChild(
        buildSelect(
          LANGUAGE_OPTIONS,
          'tcg-gap-inquiry__select tcg-gap-inquiry__select--lang',
          document.querySelector('[data-tcg-gap-filler]')?.dataset.catalogLanguage === 'en' ? 'en' : 'de'
        )
      );
      tr.appendChild(langTd);

      const condTd = document.createElement('td');
      condTd.appendChild(
        buildSelect(CONDITION_OPTIONS, 'tcg-gap-inquiry__select tcg-gap-inquiry__select--cond', 'NM')
      );
      tr.appendChild(condTd);

      const noteTd = document.createElement('td');
      const noteInput = document.createElement('input');
      noteInput.type = 'text';
      noteInput.maxLength = 200;
      noteInput.placeholder = 'optional';
      noteInput.className = 'tcg-gap-inquiry__note-input';
      noteTd.appendChild(noteInput);
      tr.appendChild(noteTd);

      tableBody.appendChild(tr);
    });
  };

  const collectItems = () => {
    if (!tableBody) return [];
    return Array.from(tableBody.querySelectorAll('tr[data-slot-id]')).map((row) => {
      const slotId = row.dataset.slotId || '';
      const language = row.querySelector('.tcg-gap-inquiry__select--lang')?.value?.trim() || 'de';
      const conditionMin = row.querySelector('.tcg-gap-inquiry__select--cond')?.value?.trim() || 'NM';
      const note = row.querySelector('.tcg-gap-inquiry__note-input')?.value?.trim() || '';
      return { slot_id: slotId, language, condition_min: conditionMin, note };
    });
  };

  const languageLabel = (code) => LANGUAGE_OPTIONS.find((o) => o.value === code)?.label || code;

  const formatSlotLine = (slotId, index, item) => {
    const entry = resolveEntry(slotId);
    const extras = [];
    if (item?.language) extras.push(`Sprache: ${languageLabel(item.language)}`);
    if (item?.condition_min) extras.push(`Zustand min.: ${item.condition_min}`);
    if (item?.note) extras.push(`Notiz: ${item.note}`);
    const suffix = extras.length ? ` (${extras.join(', ')})` : '';
    return `${index + 1}. ${entry.setName} · ${entry.number} · ${entry.name} · ${entry.variantLabel}${suffix}`;
  };

  const buildContactBody = (email, name, phone, message, items) => {
    const cardLines = items.map((item, i) => formatSlotLine(item.slot_id, i, item)).join('\n');
    const blocks = [
      'Lückenfüller-Wunschliste über kartenladen24.de',
      '',
      `Kunden-E-Mail: ${email}`,
    ];
    if (name) blocks.push(`Name: ${name}`);
    if (phone) blocks.push(`Telefon: ${phone}`);
    blocks.push(`Anzahl Karten: ${items.length}`);
    if (message) {
      blocks.push('', 'Nachricht des Kunden:', message);
    }
    blocks.push('', 'Gewünschte Karten:', cardLines);
    blocks.push('', '---', 'Technische Slot-IDs:', items.map((i) => i.slot_id).join(', '));
    return blocks.join('\n');
  };

  const cleanReturnUrl = () => {
    const params = new URLSearchParams(window.location.search);
    let changed = false;
    if (params.has('wishlist_sent')) {
      params.delete('wishlist_sent');
      changed = true;
    }
    if (params.has('section')) {
      params.delete('section');
      changed = true;
    }
    if (window.location.hash && /wishlist|GapWishlist|contact/i.test(window.location.hash)) {
      changed = true;
    }
    if (!changed) return;
    const nextQuery = params.toString();
    const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}`;
    window.history.replaceState({}, '', nextUrl);
  };

  const setModalMode = (mode) => {
    const isSuccess = mode === 'success';
    if (titleEl) titleEl.textContent = isSuccess ? TITLE_SUCCESS : TITLE_FORM;
    if (formView) formView.hidden = isSuccess;
    if (postSuccess) postSuccess.hidden = !isSuccess;
    root.classList.toggle('tcg-gap-inquiry--success', isSuccess);
  };

  const showFeedback = (message, type) => {
    if (!feedback) return;
    feedback.hidden = false;
    feedback.textContent = message;
    feedback.classList.remove('is-error', 'is-success');
    feedback.classList.add(type === 'success' ? 'is-success' : 'is-error');
  };

  const resetToFormView = () => {
    setModalMode('form');
    if (feedback) feedback.hidden = true;
    if (submitBtn) submitBtn.disabled = false;
    nativeSubmitPending = false;
  };

  const showSuccessPanel = (message) => {
    setModalMode('success');
    if (feedback) feedback.hidden = true;
    if (postSuccessText && message) postSuccessText.textContent = message;
  };

  const showOverlay = () => {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const updateSummary = () => {
    if (!summary || !wish) return;
    const count = wish.loadAll().length;
    summary.textContent =
      count === 1
        ? '1 Karte auf deiner Wunschliste – bitte Details prüfen und absenden.'
        : `${count} Karten auf deiner Wunschliste – bitte Details prüfen und absenden.`;
  };

  const updateButton = () => {
    if (!openButtons.length || !wish) return;
    const count = wish.loadAll().length;
    openButtons.forEach((btn) => {
      btn.disabled = count === 0;
      btn.removeAttribute('title');
    });
  };

  const clearWishlistAfterSend = async () => {
    if (!wish) return;
    try {
      wish.saveAll([]);
      await wish.syncCart([]);
    } catch {
      /* ignore */
    }
    updateButton();
    window.TcgGapFillerMain?.refresh?.();
  };

  const open = () => {
    if (!wish || wish.loadAll().length === 0) return;
    resetToFormView();
    populateTable();
    updateSummary();
    showOverlay();
    root.querySelector('[data-gap-inquiry-email]')?.focus();
  };

  const close = () => {
    overlay.hidden = true;
    document.body.style.overflow = '';
    resetToFormView();
    cleanReturnUrl();
  };

  const handlePostRedirect = async () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('wishlist_sent') !== '1') return;

    let alreadyHandled = false;
    try {
      alreadyHandled = sessionStorage.getItem(SENT_HANDLED_KEY) === '1';
    } catch {
      /* ignore */
    }
    if (alreadyHandled) {
      cleanReturnUrl();
      return;
    }

    try {
      sessionStorage.setItem(SENT_HANDLED_KEY, '1');
    } catch {
      /* ignore */
    }

    await clearWishlistAfterSend();
    showSuccessPanel(
      'Danke! Wir haben deine Anfrage erhalten und melden uns an deine E-Mail-Adresse.'
    );
    showOverlay();
    cleanReturnUrl();
  };

  openButtons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      if (btn.hasAttribute('data-gap-wishlist-drawer-inquiry')) return;
      event.preventDefault();
      open();
    });
  });
  closeBtn?.addEventListener('click', close);
  root.querySelector('[data-gap-inquiry-success-close]')?.addEventListener('click', close);
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) close();
  });

  let nativeSubmitPending = false;

  const submitToCockpit = async (payload) => {
    const bases =
      typeof window.KL24?.resolveCockpitApiBases === 'function'
        ? window.KL24.resolveCockpitApiBases()
        : [resolveCockpitApiBase()].filter(Boolean);
    if (!bases.length) return null;

    let lastError = null;
    for (const apiBase of bases) {
      try {
        const response = await fetch(`${apiBase}/integrations/gap-filler/wishlist-inquiry`, {
          method: 'POST',
          headers: cockpitHeaders(apiBase, { 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          const detail = data?.detail || data?.message || `HTTP ${response.status}`;
          throw new Error(typeof detail === 'string' ? detail : 'Anfrage fehlgeschlagen.');
        }
        return data;
      } catch (err) {
        lastError = err;
        console.warn('[KL24] Cockpit wishlist attempt failed:', apiBase, err);
      }
    }
    throw lastError || new Error('Cockpit nicht erreichbar.');
  };

  const submitShopifyFallback = (email, name, phone, message, items) => {
    if (!form || !bodyField) return;
    bodyField.value = buildContactBody(email, name, phone, message, items);
    try {
      sessionStorage.removeItem(SENT_HANDLED_KEY);
    } catch {
      /* ignore */
    }
    nativeSubmitPending = true;
    form.requestSubmit();
  };

  const finishSuccess = async (message) => {
    await clearWishlistAfterSend();
    showSuccessPanel(message);
  };

  form?.addEventListener('submit', (event) => {
    if (nativeSubmitPending) return;
    event.preventDefault();
    if (!wish || !bodyField) return;

    const email = root.querySelector('[data-gap-inquiry-email]')?.value?.trim();
    const name = root.querySelector('[data-gap-inquiry-name]')?.value?.trim();
    const phone = root.querySelector('[data-gap-inquiry-phone]')?.value?.trim();
    const message = root.querySelector('[data-gap-inquiry-message]')?.value?.trim();
    const honeypot = root.querySelector('[data-gap-inquiry-hp]')?.value?.trim();
    const items = collectItems();

    if (!email) {
      showFeedback('Bitte E-Mail angeben.', 'error');
      return;
    }
    if (!items.length) {
      showFeedback('Deine Wunschliste ist leer.', 'error');
      return;
    }
    if (honeypot) {
      showFeedback('Anfrage abgelehnt.', 'error');
      return;
    }

    submitBtn.disabled = true;
    showFeedback('Wird gesendet …', 'success');

    const cockpitPayload = {
      customer_email: email,
      customer_name: name || null,
      customer_phone: phone || null,
      customer_message: message || null,
      items,
      website: honeypot || '',
    };

    void (async () => {
      const bases =
        typeof window.KL24?.resolveCockpitApiBases === 'function'
          ? window.KL24.resolveCockpitApiBases()
          : [resolveCockpitApiBase()].filter(Boolean);

      if (bases.length) {
        try {
          const result = await submitToCockpit(cockpitPayload);
          if (result?.id) {
            const customerOk = Boolean(result.customer_notified);
            const ownerOk = Boolean(result.owner_notified);
            await finishSuccess(
              customerOk
                ? 'Danke! Wir haben deine Wunschliste erhalten – eine Bestätigung ist an deine E-Mail unterwegs.'
                : ownerOk
                  ? 'Danke! Wir haben deine Wunschliste erhalten und melden uns an deine E-Mail-Adresse.'
                  : 'Danke! Deine Wunschliste wurde gespeichert. Wir melden uns an deine E-Mail-Adresse.'
            );
            if (submitBtn) submitBtn.disabled = false;
            return;
          }
        } catch (err) {
          console.warn('[KL24] Cockpit wishlist failed, using Shopify fallback:', err);
          showFeedback('Cockpit nicht erreichbar – sende über Shop-Formular …', 'success');
        }
      }
      submitShopifyFallback(email, name, phone, message, items);
    })();
  });

  if (window.location.hash && /wishlist|GapWishlist|contact/i.test(window.location.hash)) {
    cleanReturnUrl();
  }

  if (new URLSearchParams(window.location.search).get('wishlist_sent') === '1') {
    void handlePostRedirect();
  }

  window.TcgGapWishlistInquiry = { updateButton, open, close, populateTable, handlePostRedirect };

  updateButton();
})();
